<template>
  <div class="container">
    <div>
      <div class="top-text">
        <img src="@/assets/images/footer.png" class="img-class" />
        <div>
          <div class="company">生诺医药</div>
          <div class="english-text">SINORDA<br />BIOMEDICINE</div>
        </div>
      </div>
      <div class="owner">江苏太瑞生诺生物医药科技有限公司版权所有</div>
      <div class="underline">苏ICP备14028655号-1</div>
    </div>
    <div class="link" @click="goDetail">法律声明</div>
    <!-- <div class="right">
      <div @click="jumpTo('product')" class="link">产品研发</div>
      <div @click="jumpTo('newsCenter')" class="link">新闻中心</div>
      <div class="link">人才招聘</div>
      <div @click="jumpTo('contractUs')" class="link">联系我们</div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "footerCom",
  data() {
    return {};
  },
  methods: {
    jumpTo(url) {
      this.$router.push(`${url}`);
    },
    goDetail() {
      this.$router.push(`/LegalDetail`);
    },
  },
};
</script>
<style lang="scss" scoped>
.footer {
  min-width: 1400px;
  width: 100%;
  font-size: 14px;
  color: white;
  background-color: #043ca4;
  .footer-top {
    width: 70%;
    height: 160px;
    padding-top: 40px;
    margin: auto;
    display: flex;
    .footer-introduce {
      width: 520px;
      margin-right: 72px;
      .footer-img {
        width: 160px;
        height: 64px;
        background: #ededed;
      }
      .footer-text {
        margin-top: 12px;
        line-height: 20px;
      }
    }
    .footer-link {
      display: flex;
      flex-direction: column;
      width: 140px;
      margin: 0 50px;
      a {
        font-size: 14px;
        color: #000;
        text-decoration: none;
        margin-top: 12px;
      }
      .link-type {
        font-size: 20px;
        color: rgba(4, 60, 164, 0.52);
        line-height: 30px;
        margin-bottom: 8px;
      }
    }
  }
  .footer-bottom {
    display: flex;
    justify-content: center;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #eeeeee;
    div {
      margin: 0 15px;
    }
  }
}
.container {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  background: #eeeeee;
  color: black;
  display: flex;
  align-items: center;
  padding: 24px 140px;
  justify-content: space-evenly;
}
.underline {
  margin-top: 14px;
}
.owner {
  margin-top: 20px;
}
.img-class {
  width: 18%;
  margin-right: 16px;
}
.right {
  margin-left: 150px;
  display: flex;
  align-items: center;
}
.link {
  margin-left: 40px;
}
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}
.top-text {
  display: flex;
  align-items: end;
}
.company {
  font-size: 26px;
}
.english-text {
  margin-top: 12px;
}
</style>
